import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  hoveredAlertID: '',
  hoveredCallerID: '',
  hoveredID: '',
  hoveredFrom: '',
};

const hoveredIncidentSlice = createSlice({
  name: 'hoveredIncidentSlice',
  initialState,
  reducers: {
    setHoveredAlertID(state, action) {
      const { payload } = action;
      state.hoveredAlertID = payload;
    },
    setHoveredCallerID(state, action) {
      state.hoveredCallerID = action.payload;
    },
    setHoveredID(state, action) {
      const { payload } = action;
      state.hoveredID = payload;
    },
    setHoveredFrom(state, action) {
      const { payload } = action;
      state.hoveredFrom = payload;
    },
  },
});

export const {
  setHoveredAlertID,
  setHoveredCallerID,
  setHoveredID,
  setHoveredFrom,
} = hoveredIncidentSlice.actions;
export default hoveredIncidentSlice.reducer;
